// extracted by mini-css-extract-plugin
export default {"avatar":"UserMenu_avatar__sRg9V","name":"UserMenu_name__Estw5","container":"UserMenu_container__KolyR","userData":"UserMenu_userData__Emx-Z","email":"UserMenu_email__xoBAv"};